import { createContext } from 'react';

export type ResourceId = string;

export type UseAuthorization = {
  hasPermission: (
    resourceType: 'site',
    resourceId: ResourceId | null,
    ...permissions: ['site-integrations-update']
  ) => boolean;
};

export interface LegacyContextProps {
  useAuthorization?: () => UseAuthorization;
  useTrack?: () => { optimizelyIntegration: (step: string) => void };
  usePageTitle?: (title: string) => void;
  routes?: Record<string, string>;
}

export const LegacyContext = createContext<LegacyContextProps>({});
